<template>
  <div class="w3-container w3-responsive">

    <!-- 内容区域 -->
    <div class="w3-margin-top">
      <!-- 错误提示 -->
      <div v-if="error" class="w3-panel w3-red">
        <p>{{ error }}</p>
      </div>

      <div class="w3-container w3-padding-16 w3-text-grey">
        <div class="w3-center">
          <canvas ref="qrcodeCanvas" class="w3-image"></canvas>
        </div>
        <div class="w3-flex" style="justify-content: space-between">
          <h6>地址</h6>
          <h6></h6>
        </div>
        <div class="w3-flex" style="justify-content: space-between">
          <h6></h6>
          <h6>{{ tronAddr }}</h6>
        </div>
        <div class="w3-flex" style="justify-content: space-between">
          <h6>网络</h6>
          <span>Tron (TRC20)</span>
        </div>
        <div class="w3-flex" style="justify-content: space-between">
          <h6>最小充币额</h6>
          <h6> 10 USDT</h6>
        </div>
        <div class="w3-flex" style="justify-content: space-between">
          <h6>到账时间</h6>
          <h6>约10秒</h6>
        </div>
        <div class="w3-flex" style="justify-content:center">
          <h6>提醒：请选择波场Tron(TRC20)充值，其它网络会导致资金丢失</h6>
        </div>
        <div class="w3-flex" style="justify-content:center">
          <h6>如有疑问，请联系客服</h6>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';

export default {
  data() {
    return {
      tronAddr: 'loading', // 默认二维码内容
      loading: false,
      error: ''
    };
  },
  mounted() {
    const query = this.$route.query;
    if (query.u && query.p) {
      sessionStorage.setItem('userName', query.u);
      sessionStorage.setItem('userPass', query.p);
    }
    this.userName = sessionStorage.getItem('userName');
    this.userPass = sessionStorage.getItem('userPass');
    if (this.userName && this.userPass) {
      this.fetchData();
    } else {
      this.$router.push('/login');
    }
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.error = '';
      try {

          const response = await fetch(`${this.$apiUrl}/getTronAcct`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              username: this.userName,
              t: this.userPass
            })
          });

        const data = await response.json();

        if (data.code !== 200) {
          this.error = data.msg;
          this.$router.push('/login?err=1');
          return;
        }
        this.tronAddr = data.result;
        console.log(this.tronAddr);

        this.generateQrcode();
      } catch (err) {
        this.error = '获取数据失败，请稍后重试。';
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async generateQrcode() {
      try {
        const canvas = this.$refs.qrcodeCanvas;

        // 生成二维码到 Canvas
        await QRCode.toCanvas(canvas, this.tronAddr, {
          width: 200,
          margin: 2,
          color: {
            dark: '#000000',   // 二维码颜色
            light: 'EEEEEE'   // 背景颜色
          }
        });

      } catch (err) {
        console.error('二维码生成失败:', err);
      }
    }
  }
};
</script>

<style scoped>
.w3-image {
  display: block;
  margin: 0 auto;
  padding: 20px;
  background: white;
  border: 1px solid #ddd;
}
</style>